module.exports = __webpack_public_path__ + "img/carrousel-video-7.773d795f.png";